<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Aj4GVe/images/cover.jpg?1684514595630" alt="This image is the cover for the book Servitude, Reagalos"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Servitude, Reagalos
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Reagalos: Book One</i></b></p><p>Lornyc Reagalos, future High Lord of the city of Katraman, enjoys his life as a student, even if he has to keep his relationship with Methian Hadral, heir to the throne of Xenetra, a secret. Unfortunately, Lornyc isn’t just any royal student—he’s also the grandson of an infamous magic user named Romanus Reagalos, and his grandfather’s wild youth is about to catch up with him. Unknown to anyone else, Romanus saw fit to sign his grandson into the life of a valet. Specifically, <em>Methian’s </em>valet.</p> <p>The contract—and the strain it puts on his relationship with Methian—is just the start of Lornyc’s troubles. Though the Reagalos family was once famous for its magic, Lornyc’s father never showed any aptitude, and Lornyc hasn’t either—though that doesn’t make the <em>next </em>contract, the one that says Lornyc must learn to use his latent powers, any less binding. When Lornyc learns of a plot to remove his father from power, he finds himself racing against time. If he can’t master his magic and identify the leader of the plot, he stands to lose everything he knows and loves: his parents, his rank, and Methian.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rebecca Cohen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58e38f58